export var Barcode = function(barcode) {
	this.type = undefined;
	this.barcode = barcode;
	this.action = undefined;
	this.printer = undefined;

	if ("s" === barcode.substr(0,1).toLowerCase()) {
		this.action = "split";
		barcode = barcode.substr(1);
		this.barcode = barcode;
	}

	if (10 === barcode.length || 21 === barcode.length) // Pil første karakter af, hvis stregkoden er for lang?
		barcode = barcode.substr(1);

	if (9 === barcode.length && "L" === String.fromCharCode(barcode.substr(0,2))) { // Tjek om det er en lokationsetikette
		this.type = "location";
		this.location_parts = [
			barcode.substr(2,1),
			String.fromCharCode(barcode.substr(3,2)),
			parseInt(barcode.substr(5,2)),
			".",
			parseInt(barcode.substr(7,2))
		];
		this.location = this.location_parts.join("");
		if ("0P" == this.location.substr(0,2)) {
			this.type = "printer";
			this.printer = this.location.substr(2).replace(".","");
			// this.selectPrinter();
		}
	} else if (20 === barcode.length) { // Ellers er det en vareetikette
		this.type = "item";
		this.rownumber = (barcode.substr(11,9) - 100000000);
		this.itemnumber = barcode.substr(0,6);
		this.qty = barcode.substr(7,4) * Math.pow(10, -(barcode.substr(6,1)));
		if(0 === this.qty)
			this.type = "pluk";
	} else {
		throw "Ikke en gyldig stregkode";
	}

	this.getType = function(){
		return this.type;
	}

	this.split = function( qty, printer ){
		return jQuery.post(
			'./barcode_system/split/'+this.barcode+"/"+qty+"/"+(printer || ""),
			function(data){
				if (resp = data.match(/^Error: (.*)/)) {
					ion.sound.play("computer_error");
					message = alertManager.error(resp[1]).showFloated();
					// console.log(resp[1]);
				}
			}
		);
	}

	this.move = function( location ) {
		var self = this;
		// Prøv at flytte varen.
		var promise = Promise.resolve(jQuery.post('./barcode_system/location_move_item/'+self.barcode+'/'+encodeURIComponent(location)));
		promise = promise.then(function(data){
			try {
				// For bagudkompatibilitetens skyld tjekker vi om svaret er et JSON-objekt.
				if(typeof data !== "object")
					data = JSON.parse(data);

				// Hvis det er et JSON-objekt, og der står at etiketten er inaktiv, så laver vi en dialog-boks,
				// hvor brugeren skal skrive "JA" (case-insensitive) for at reaktivere etiketten.
				// I stedet for det oprindelige promise fra ajax-requesten, returnerer vi nu promiset fra dialog-boksen.
				if (data.inactive) {
					// Spil da lige en lyd først, så brugeren kigget på skærmen.
					ion.sound.play("computer_error");
					return promise_dialog({
						modal_size: "sm",
						title: "Genaktiver inaktiv etiket?",
						body: "<input data-keep-focus='true' style='width:100%;' placeholder=\"Skriv 'JA' for at genaktivere etiketten.\" onkeyup=\"if(this.value.toUpperCase()=='JA'){jQuery('#approved-reactivation').removeAttr('disabled')}else{jQuery('#approved-reactivation').attr('disabled','disabled')}\" />",
						buttons: [
							{title: "Annullér", reject: "Etiketten blev ikke genaktiveret eller flyttet!"},
							{title: "Genaktiver", resolve: "approve", attributes: {id: "approved-reactivation", disabled:'disabled'}},
						],
					}).then(function(){
						// Hvis brugeren har skrevet "JA", så bliver dialogboksens promise resolved,
						// og så sender vi en ny forespørgsel om at flytte varen og samtidig genaktivere den.
						// Vi returnerer promiset fra den nye forespørgsel i stedet, så det nu er den vi venter på i stedet.
						return Promise.resolve(jQuery.post('./barcode_system/location_move_item/'+self.barcode+'/'+encodeURIComponent(location)+'/reactivate')).then(function(data){
							if (typeof data === "string" && (resp = data.match(/^Error: (.*)/))) {
								throw resp[1];
							}
						});
					});
				}
			} catch (err) {
				// Hvis det ikke var et JSON-objekt, og noget andet gik galt, så rejecter vi promiset.
				if (typeof data === "string" && (resp = data.match(/^Error: (.*)/))) {
					throw resp[1];
				}
			}
		});

		return promise;
	}

	this.selectPrinter = function() {
		return jQuery.post(
			'./barcode_system/select_printer/'+this.location,
			function(data){
				if ((typeof data == "string") && (resp = data.match(/^Error: (.*)/))) {
					ion.sound.play("computer_error");
					message = alertManager.error(resp[1]).showFloated();
					// console.log(resp[1]);
				}
				if( typeof data == "string" )
					return JSON.parse(data);
				return data;
			}
		);
	}

	return this;
}


//////////////////
// WEBPACK FOOTER
// ./public_html/scripts/classes/_barcode.js
// module id = 7
// module chunks = 0